import _sfc_main from "./indexH5.vue2.mjs";
/* empty css              */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "contact-container-main" }, [_c("div", { staticClass: "contact-title-main" }, [_c("div", [_vm._v(_vm._s(_setup.t("Contact us")))]), _c("span", { directives: [{ name: "tap", rawName: "v-tap", value: _setup.handleCloseContact, expression: "handleCloseContact" }], staticClass: "cancel" }, [_vm._v(_vm._s(_setup.t("Cancel")))])]), _vm._l(_setup.contactContentList, function(item) {
    return _c("div", { key: item.id, staticClass: "contact-content-main" }, [_c("span", { staticClass: "contact-title" }, [_vm._v(_vm._s(_setup.t(item.title)))]), _c("span", { staticClass: "contact-content" }, [_vm._v(_vm._s(item.content))]), _c(_setup.SvgIcon, { directives: [{ name: "tap", rawName: "v-tap", value: () => _setup.onCopy(item.copyLink), expression: "() => onCopy(item.copyLink)" }], staticClass: "copy", attrs: { "icon": _setup.CopyIcon } })], 1);
  }), _c("span", { staticClass: "contact-bottom" }, [_vm._v(" " + _vm._s(_setup.t("If you have any questions, please feel free to join our QQ group or send an email")) + " ")])], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a59c234f"
);
const indexH5 = __component__.exports;
export {
  indexH5 as default
};
